module.exports = __webpack_public_path__ + "img/IMG_1401_L_Black.911e0822.jpg";